export enum PartnerPaymentStatus {
  pending = 'pending',
  paid = 'paid',
}

export namespace PartnerPaymentStatus {
  export const translateStatus = (type: PartnerPaymentStatus): string => {
    switch (type) {
      case PartnerPaymentStatus.pending:
        return "Pendente";
      case PartnerPaymentStatus.paid:
        return "Pago";
      default:
        return "";
    }
  };

  export const PartnerPaymentStatusChoices = Object.values(PartnerPaymentStatus).filter(x => typeof x === "string")
  .map(status => {
    return ({
      id: status,
      name: PartnerPaymentStatus.translateStatus(status)
    });
  });
}
